<div class="layout-wrapper h-screen w-screen" [ngClass]="containerClass()">
    <div app-sidebar></div>
    <div class="layout-content-wrapper">
        <div class="layout-content-wrapper-inside">
            <div app-topbar></div>
            <div class="layout-content">
                <p-toast class="shrink-0"></p-toast>
                <p-confirmDialog #cd [style]="{ width: '450px' }" />
                <router-outlet (activate)="onComponentActivate($event)"></router-outlet>
            </div>
            <!--<div app-footer></div>-->
        </div>
    </div>
    <app-layout-configurator />
    <div app-search></div>
    <div app-rightmenu></div>
    <div class="layout-mask animate-fadein"></div>
</div>